module.exports = "\n<div class=\"content plan-details\">\n\t<div class=\"info-section\">\n\t    <p align=\"center\">You need to enter zip code or fully qualified address.</p>\n\t     <br><br>\n\t\t<div class=\"btn-action\">\n\t\t\t<button mat-button type=\"button\" routerLink=\"/enroll\" class=\"btn-block btn-green\">Let me try again</button>\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/fully-qaulified-address/fully-qaulified-address.component.html
// module id = ./src/app/shared/fully-qaulified-address/fully-qaulified-address.component.html
// module chunks = main